import SFMLContainer from "./container";
import SFML from "./component";
export { SFML, SFMLContainer };
export default SFMLContainer;



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/SFML/index.ts